/*
    PARÁMETROS DE ENTRADA
      1 = No confirmadas
      2 = Confirmadas
*/

import * as Constantes from '../../../shared/constants';

// módulos
import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

// servicios
import { EntradasService } from 'src/app/services/datos/entradas.service';
import { NotificacionesService } from 'src/app/services/notificaciones.service';
import { ClientesService } from 'src/app/services/datos/clientes.service';
import { ModalFactEntradaService } from 'src/app/services/modal-fact-entrada.service';

// interfaces
import { IEntrada } from 'src/app/interfaces/entrada';
import { IListaOpciones } from 'src/app/interfaces/lista-opciones';
import { ICliente } from 'src/app/interfaces/cliente';

// Librerías
import { ColumnMode } from '@swimlane/ngx-datatable';
import * as XLSX from 'xlsx';
import { Subscription } from 'rxjs';
import FuncLib from 'src/app/providers/funcionesLib';
import { environment } from 'src/environments/environment';
import Swal from 'sweetalert2';
import { AvisosService } from 'src/app/services/datos/avisos.service';
import { SidebarService } from 'src/app/services/sidebar.service';

@Component({
  selector: 'app-entradas-ubicadas-lista',
  templateUrl: './entradas-ubicadas-lista.component.html',
  styleUrls: ['./entradas-ubicadas-lista.component.scss'],
})
export class EntradasUbicadasListaComponent implements OnInit {

  //Usar constantes en el template
  Constantes = Constantes;

  // Librería de Funciones comunes
  public funcLib: FuncLib = new FuncLib();

  @ViewChild('myTable') table: any;

  public fotoDir: string = environment.fotoDir;
  public imgResized: string = localStorage.getItem('imgResized') || '/resize/';
  imagenSeleccionada: string | null = null;

  public enviado: boolean = false;

  public clientesList: ICliente[] = [];
  public entradasTotales: any = null;

  opcionesList: IListaOpciones = {};
  cliSeleccionado: string = '';

  // Errores
  public errores: any = {};

  // Control de cuando se cierra el modal
  modalClosedSubscription: Subscription | undefined;

  public loading: boolean = false;

  public lista: IEntrada[] = [];
  public rows: any = [];
  public temp: any[] = [];

  public swEnStock: string = '1'; // 1=Pendiente de Ubicar fisicamente, 2= Está fisicamente en el almacén
  public subTitulo: string = '';

  public messages = {
    emptyMessage: `<span class="text-danger">Sin datos...</span>`,
    totalMessage: 'Total',
    selectedMessage: 'seleccionado'
  }

  expanded: any = {};
  timeout: any;

  ColumnMode = ColumnMode;
  public summaryPosition: string =
    localStorage.getItem('summaryPosition') || 'bottom';
  public rowsLimitStr: string = localStorage.getItem('linTablas') || '10';
  public rowsLimit: number = parseInt(this.rowsLimitStr);

  textoDestacado: string = '';
  public strBuscarTodo: string = '';


  // Cargar más
  public mostrarCargaMas: boolean = true; // si activamos un filtro, se desactiva el botón de cargar más
  concatData: boolean = false;
  recDesde: number = 0; // Desde dónde cargar
  recCuantos: number = parseInt(localStorage.getItem('recCuantasEntradas') || '100'); // Cuantos cargar
  recTotal: number = 0; // Total de registros


  constructor(
    public modalFactEntradaSrv: ModalFactEntradaService,
    private clientesSrv: ClientesService,
    public entradaSrv: EntradasService,
    private notificacionesSrv: NotificacionesService,
    private activatedRoute: ActivatedRoute,
    private avisosSrv: AvisosService,
    private sidebarSrv: SidebarService
  ) { }

  ngOnInit(): void {
    // Suscribirse a los parámetros de la url
    this.activatedRoute.params.subscribe((params) => {
      const swEnStockParam = params['swEnStock'];

      // Cambia el parámetro swEnStock y resetea la lista
      if (swEnStockParam && swEnStockParam !== this.swEnStock) {
        this.swEnStock = swEnStockParam;
        this.recDesde = 0;
        this.recCuantos = parseInt(localStorage.getItem('recCuantasEntradas') || '100'); // Cuantos cargar
        this.lista = [];
      }
      this.subTitulo = 'Pendientes de ubicar físicamente en el almacén';
      if (this.swEnStock === '2')
        this.subTitulo = 'TODOS los artículos Están fisicamente en el almacén';
      this.rows = [];
      this.cargaClientes();
      this.getListaEntradas();
      this.cargaEntradasTotales();
    });


    this.sidebarSrv.expandMenu('entradas'); // Forzar el abrir menú de Entradas

    this.modalClosedSubscription =
      this.modalFactEntradaSrv.modalClosed.subscribe(() => {
        // Suscribirse a modalClosed para saber cuando se cierra el modal y actualizar los datos de los pedidos
        console.log('__El modal se ha cerrado...:');
        this.getListaEntradas();
      });


  }


  getListaEntradas() {
    this.opcionesList = {
      swCompleto: '1',
      swEnStock: this.swEnStock,
      recDesde: this.recDesde,
      recCuantos: this.recCuantos
    };
    if (this.cliSeleccionado) this.opcionesList.id_cliente = parseInt(this.cliSeleccionado);

    console.log('__opcionesList', this.opcionesList);

    this.loading = true;
    this.entradaSrv.getLista(this.opcionesList).subscribe((resp) => {
      this.loading = false;
      this.limpiaBusca();

      if (resp.error) {
        this.notificacionesSrv.aviso('error', resp.mensaje);
        return;
      }

      this.recTotal = parseInt(resp.totales.totalRegistros || '0');

      if (this.concatData) {
        this.lista = this.lista.concat(resp.data);
      } else {
        this.lista = resp.data;
      }
      this.concatData = false;

      console.log('__getListaEntradas() recDesde: ', this.recDesde);
      console.log('__getListaEntradas() recTotal: ', this.recTotal);
      console.log('__getListaEntradas() lista: ', this.lista);

      this.rows = this.lista;
      this.temp = [...this.lista];
    });
  }

  deleteRow(row: any) {
    Swal.fire({
      title: '¿Estás seguro de que quieres borrar esta entrada?',
      text: 'Esta acción no se puede deshacer.',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Sí, borrar',
      cancelButtonText: 'Cancelar',
    }).then((result) => {
      if (result.isConfirmed) {
        this.loading = true;
        this.entradaSrv.delete(row.id).subscribe(
          (resp) => {
            this.loading = false;
            if (resp.error) {
              this.notificacionesSrv.aviso('error', resp.mensaje);
            } else {
              this.notificacionesSrv.aviso('success', 'Entrada borrada correctamente');
              this.getListaEntradas();
            }
          },
          (error) => {
            this.loading = false;
            this.notificacionesSrv.aviso('error', 'Error al borrar la entrada');
          }
        );
      }
    });
  }


  //// AUX ////

  cargaMas() {
    this.concatData = true;
    this.recDesde += this.recCuantos;
    if (this.recDesde > this.recTotal) this.recDesde = this.recTotal;

    console.log('__cargaMas() recDesde: ', this.recDesde);
    this.getListaEntradas();
  }


  // Datos de estadísticas
  cargaEntradasTotales() {
    this.entradaSrv.entradasTotales().subscribe((resp) => {
      this.entradasTotales = resp.data;
      console.log('__cargaEntradasTotales()', resp);
    });
  }

  cargaClientes() {
    this.clientesSrv.getLista().subscribe((resp) => {
      this.clientesList = resp.data.filter(
        (cliente: { archivado: boolean }) => !cliente.archivado
      );
    });
  }


  onClienteSelect(id: string) {
    this.cliSeleccionado = id;
    this.recDesde = 0;
    this.getListaEntradas();
    this.limpiaBusca();
  }


  // Número de errores en el formulario
  getErroresLength(): number {
    return Object.keys(this.errores).length;
  }

  onPage(event: any) {
    clearTimeout(this.timeout);
    this.timeout = setTimeout(() => {
      console.log('paged!', event);
    }, 100);
  }

  onActivate(event: any) {
    if (event.type === 'click') {
      const target = event.event.target;
      const isDropdownOrIcon = target.closest('.dropdown-toggle') ||
        target.closest('.datatable-icon-right') ||
        target.closest('.datatable-icon-down') ||
        target.closest('.dropdown-item') ||
        target.closest('a') ||
        target.closest('button');
      if (!isDropdownOrIcon) {
        this.toggleExpandRow(event.row);
      }
    }
  }

  toggleExpandRow(row: any) {
    console.log('Toggled Expand Row!', row);
    if (this.table && this.table.rowDetail) {
      this.table.rowDetail.toggleExpandRow(row);
    }
  }

  onDetailToggle(event: any) {
    console.log('Detail Toggled', event);
  }

  rowsLimitChange() {
    this.rowsLimit = parseInt(this.rowsLimitStr); // convertir el valor a número
  }

  buscarTodo(event: any) {
    const txt = event?.target?.value?.toLowerCase() ?? '';
    const temp = this.temp.filter((d: any) =>
      Object.keys(d).some(
        (key: any) =>
          d[key] && d[key].toString().toLowerCase().includes(txt.toLowerCase())
      )
    );
    this.textoDestacado = txt;
    this.rows = temp;
    // Whenever the filter changes, always go back to the first page
    if (this.table && this.table.offset) {
      this.table.offset = 0;
    }
  }

  buscaGlobal(txt: string) {
    const temp = this.temp.filter((d: any) =>
      Object.keys(d).some(
        (key: any) =>
          d[key] && d[key].toString().toLowerCase().includes(txt.toLowerCase())
      )
    );

    // Marcar el texto destacado
    this.textoDestacado = txt;

    // update the rows
    this.rows = temp;
    // Whenever the filter changes, always go back to the first page
    if (this.table && this.table.offset) {
      this.table.offset = 0;
    }
  }


  limpiaBusca() {
    this.strBuscarTodo = '';
    this.buscaGlobal('');
    const buscaTodoInput = document.getElementById('buscaTodo');
    buscaTodoInput?.focus();
  }


  // Exportar a Excel
  exportToExcel(): void {
    const fileName = `entradas-ubicadas-${new Date().toISOString()}.xlsx`;
    const worksheet = XLSX.utils.json_to_sheet(this.rows);
    const workbook = XLSX.utils.book_new();

    // Forzar valores numéricos en las columnas Xlsx
    Object.entries(worksheet).forEach(([cell, cellObj]) => {
      if (!cell.startsWith('!') && !isNaN(cellObj.v) && cellObj.v !== '') {
        cellObj.v = Number(cellObj.v);
        cellObj.t = 'n';
      }
    });

    XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
    XLSX.writeFile(workbook, fileName);
  }

  creaPdf(data: any) {
    // monta un html con los datos de la ínea y llama al método para crear convertirlo en PDF
    console.log('__creaPdf()', data);

    this.notificacionesSrv.aviso('info', 'Generando PDF...');
    let htmlString: string = '';

    // Estilos
    let estilos: string = `
      <style>
        h1, h2, h3, h4, h5, h6 {
          font-family: Arial, sans-serif;
        }
        .descripcion {
          font-size: 0.7em;
        }
        table {
          border-collapse: collapse;
          width: 100%;
          font-family: Arial, sans-serif;
        }
        th, td {
          border: 1px solid black;
          padding: 8px;
          text-align: left;
        }
        th {
          background-color: #f2f2f2;
        }
        .no-border td {
          border: none !important;
          padding: 5px;
        }
      </style>
      `;

    // Cabecera
    let cabecera: string = `
      <h1>InnovaCen - Entrada ubicada</h1>
      <table style="width: 100%;" border="1">
        <tr>
          <th>Almacén</th>
          <th>Cliente</th>
          <th>Albarán</th>
          <th>Proveedor</th>
          <th>Fecha Entrada</th>
        </tr>
        <tr>
          <td>${data.almNombre}</td>
          <td>${data.cliNombre}</td>
          <td>${data.albaran}</td>
          <td>${data.proveedor}</td>
          <td>${data.created_at}</td>
        </tr>
      </table>
      <h2>Ubicaciones</h2>
      <table style="width: 100%;" border="1">`;

    let cabeceraPale: string = `
        <tr>
          <th>Palé</th>
          <th>EAN</th>
          <th>SKU</th>
          <th>Descripción</th>
          <th>Lote</th>
          <th>Cantidad</th>
          <th>Ubicación</th>
        </tr>
      `;

    // Montar html
    htmlString = estilos + cabecera + cabeceraPale;

    // detalles
    let paleAnterior = '';
    data.detall.forEach((detalle: any) => {
      // palé, Cabecera si cambia
      if (detalle.pale !== paleAnterior) {
        if (paleAnterior !== '') {
          htmlString += `<tr class="no-border"><td colspan="7"> </td></tr>`;
          htmlString += cabeceraPale;
        }
        paleAnterior = detalle.pale;
      }

      // Formatear valores
      let loteWk = '';
      if (detalle.lote) loteWk = detalle.lote;
      const ubicacionPuntos = this.funcLib.punteaUbicacion(detalle.ubicacion); // Para formato de número con puntos
      const cantidadWk = parseInt(detalle.cantidad).toLocaleString('de-DE');

      htmlString += `
        <tr>
          <td style="text-align: right;">${detalle.pale}</td>
          <td style="white-space: nowrap;">${detalle.artEan}</td>
          <td  class="descripcion" style="white-space: nowrap;">${detalle.artSku}</td>
          <td class="descripcion">${detalle.artDescripcion}</td>
          <td style="white-space: nowrap;">${loteWk}</td>
          <td style="text-align: right;">${cantidadWk}</td>
          <td>${ubicacionPuntos}</td>
        </tr>
      `;
    });

    // Cerrar la tabla y agregar el final del HTML
    htmlString += `</table>`;

    const datos = {
      html: htmlString,
      pdfName: 'entrada_' + data.id,
      // Enviar id_usuario si se quiere imprimir automáticamente por la laser del usuario
      // 'id_usuario': this.usuarioSrv.userdata.id
    };

    this.loading = true;
    this.entradaSrv.creaPdf(datos).subscribe((resp) => {
      this.loading = false;
      console.log(resp);
      if (resp.error) {
        this.notificacionesSrv.aviso('error', resp.mensaje);
        return;
      }

      const urlPdf: string = environment.pdfDir + '/work/' + resp.data.pdfName;
      window.open(urlPdf, '_blank');
      this.notificacionesSrv.aviso('success', resp.mensaje);
    });
  }

  modalFacturacion(row: any) {
    // Abre el modal para editar los datos de facturación

    console.log('__modalFacturacion()', row);

    this.modalFactEntradaSrv.entrada = row;
    this.modalFactEntradaSrv.abrirModal();
  }

  confirmaFinalizar(row: any) {
    Swal.fire({
      title: '¿Confirmar entrada?',
      icon: 'question',
      html: `<b>${row.albaran}</b> ¿Quieres confirmar el movimiento físico de los artículos de esta entrada en el almacén?`,
      showCancelButton: true,
      cancelButtonText: 'Cancelar',
      confirmButtonText: 'Si',
    }).then((result) => {
      if (result.isConfirmed) {
        this.finalizaEntrada(row);
      }
    });
  }

  confirmarTodo() {
    Swal.fire({
      title: `¿Confirmar <b>${this.lista.length}</b> entrada/s?`,
      icon: 'warning',
      html: `¿Quieres confirmar el movimiento físico de todos los artículos de estas entrada/s en el almacén?`,
      showCancelButton: true,
      cancelButtonText: 'Cancelar',
      confirmButtonText: 'Si',
    }).then((result) => {
      if (result.isConfirmed) {
        const data = this.lista.map((entrada) => ({ id_entrada: entrada.id }));
        console.log('confirmarTodo()', data);
        this.finalizaTodasEntradas(data);
      }
    });
  }

  finalizaEntrada(row: any) {
    // Marca la entrada como finalizada
    const data = { id_entrada: row.id };
    this.loading = true;
    this.entradaSrv.confirmar(data).subscribe((resp) => {
      this.loading = false;
      if (resp.error) {
        this.notificacionesSrv.aviso('error', resp.mensaje);
        return;
      }
      this.notificacionesSrv.aviso('success', resp.mensaje);
      this.getListaEntradas();
      this.cargaEntradasTotales();
    });
  }

  finalizaTodasEntradas(data: any) {
    // Marca TODAS las entradas como finalizadas
    this.loading = true;
    this.entradaSrv.confirmarGrupo(data).subscribe((resp) => {
      this.loading = false;
      if (resp.error) {
        this.notificacionesSrv.aviso('error', resp.mensaje);
        return;
      }
      this.notificacionesSrv.aviso('success', resp.mensaje);
      this.getListaEntradas();
      this.cargaEntradasTotales();
    });
  }

  avisarCliente(entrada: IEntrada) {
    Swal.fire({
      title: '<i class="fa-solid fa-laptop"></i> Enviar notificación',
      text: `Escribe el mensaje para ${entrada.cliNombre} referente a su entrada`,
      input: 'textarea',
      inputValue: `Referente a la entrada con albarán ${entrada.albaran}...`,
      inputPlaceholder: 'Escribe tu mensaje aquí...',
      showCancelButton: true,
      confirmButtonText: 'Enviar notificación',
      cancelButtonText: 'Cancelar',
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      inputValidator: (value) => {
        if (!value || value.trim().length < 4) {
          return 'El mensaje debe contener al menos 4 caracteres';
        }
        return null;
      },
    }).then((result) => {
      if (result.isConfirmed && result.value) {
        const texto = result.value.trim();
        const data = {
          id_cliente: entrada.id_cliente,
          tipo: Constantes.AVISO_TIPO_ENTRADA,
          buscar_pedido: entrada.albaran,
          mensaje: texto,
        };

        this.avisosSrv.avisoNew(data).subscribe((resp) => {
          if (resp.error) {
            this.notificacionesSrv.aviso('error', resp.mensaje);
            return;
          }
          this.notificacionesSrv.aviso('success', resp.mensaje);
        });
      }
    });
  }

  ///// AUX  ///// 

  public sumaCeldas(cells: any[]) {
    // Devuelve la suma de la columna, formateada y sin decimales
    const filteredCells = cells.filter((cell) => !!cell);
    const sum: number = filteredCells.reduce(
      (accumulator, currentValue) => accumulator + parseFloat(currentValue),
      0
    );
    // return sum.toLocaleString('es');
    return sum.toLocaleString('de-DE');
  }

  public sumaCeldasLength(cells: any[]): any {
    // Devuelve la suma de longitudes de la columna
    const filteredCells = cells.filter((cell) => !!cell);
    const sum: number = filteredCells.reduce(
      (accumulator, currentValue) =>
        accumulator + (Array.isArray(currentValue) ? currentValue.length : parseFloat(currentValue) || 0),
      0
    );
    return sum.toLocaleString('de-DE');
  }

  public labelTotales(cells: any[]): any {
    return 'Totales';
  }

  // Modal imágen
  abrirPopupImagen(url: string) {
    console.log('__abrirPopupImagen()', url);
    if (url.includes('_noFoto')) return
    this.imagenSeleccionada = url;
  }

  cerrarPopupImagen() {
    this.imagenSeleccionada = null;
  }

}

